import { t } from "i18next";
import { formatAge } from "../../../utils/utils";

export const recordTablesData = [
  {
    key: "Allergens",
    title: "allergy",
    columns: [{ header: "name", colKey: "Name" }],
  },
  {
    key: "Diagnosis",
    title: "diagnosis",
    columns: [{ header: "name", colKey: "Name" }],
  },
  {
    key: "Surgeries",
    title: "surgeries",
    columns: [
      { header: "name", colKey: "Name" },
      { header: "surgery_date", colKey: "SurgeryDate" },
      { header: "note", colKey: "Note" },
    ],
  },
  {
    key: "Medications",
    title: "medications",
    columns: [
      {
        header: "name",
        colKey: "PackageName",
        render: (row: any) => {
          return (
            <div>{row?.PackageName ?? row?.Name ?? row?.CustomDrugName}</div>
          );
        },
      },

      { header: "dose", colKey: "DosageNum" , render: (row: any) => {
          return <div>{row?.DosageNum ? row?.DosageNum +" " +(row?.DosageFormUnitName ?? "") : "---"}</div>
        }},
      { header: "times", colKey: "Times" },
      { header: "duration", colKey: "Duration" , render: (row: any) => {
          return <div>{row?.Duration ? row?.Duration +" " + t("days") : "---"}</div>;
        }, },
      {
        header: "frequency",
        colKey: "Frequency",
        render: (row: any) => {
          return <div>{t(row?.Frequency?.toLowerCase())}</div>;
        },
      },
      { header: "meal", colKey: "Meal" },
      {
        header: "sleep",
        colKey: "Sleep",
        render: (row: any) => {
          return <div>{row?.Sleep ? t("before_sleep") : "---"}</div>;
        },
      },
      { header: "instructions", colKey: "Instructions" },
    ],
  },
  {
    key: "Families",
    title: "families",
    columns: [
      { header: "relation", colKey: "Name" },
      {
        header: "living_status",
        colKey: "LivingStatus",
        render: (row: any) => {
          return (
            <div className="flex flex-wrap gap-1">
              {`${t(row?.LivingStatus?.toLowerCase())} ${row?.DateOfBirth
                  ? row?.DateOfBirth &&
                  `(${formatAge(row?.DateOfBirth, true)} ${t("years_old")})`
                  : (row?.DateOfDeath ?? "")
                }`}
            </div>
          );
        },
      },

      {
        header: "diseases",
        colKey: "Diseases",
        render: (row: any) => {
          return (
            <div className="flex flex-wrap gap-1">
              {row?.Diseases?.map((item: any) => (
                <div className="rounded-lg bg-white p-1">{item?.Name}</div>
              ))}
            </div>
          );
        },
      },
    ],
  },
  {
    key: "Diseases",
    title: "Diseases",
    columns: [
      { header: "name", colKey: "Name" },
      { header: "year_diagnosed", colKey: "SinceDate" },
    ],
  },
];
